import React, { useContext, useEffect, useState } from 'react';
import { Modal, message, Form, Input, Select } from 'antd';
import { Context } from '../../../defaults';
import { createSubjects, updateSubjects } from '../../../actions';
import { studyYearRegex } from '../../../common';
import { MaskedInput } from 'antd-mask-input';

export function SubjectsModal({ modalProps, languagesType, closeModal }) {
  const { actionType, visible, currentSubject } = modalProps;
  const { dictionary, language, setLoading } = useContext(Context);
  //const { languagesType, institutions } = selectValue;
  const [studyYear, setStudyYear] = useState();
  const [form] = Form.useForm();
  const modalTitle =
    actionType === 'save'
      ? `${dictionary?.CreateSubject[language]}`
      : `${dictionary?.EditSubject[language]}`;
  const requiredMessage = `${dictionary?.RequiredField[language]}`;


  const initialState = {
    name: '',
    description: '',
    langId: '',
    institutionId: null,
    studyYear: null,
  };

  useEffect(() => {
    actionType === 'edit' && form.setFieldsValue(currentSubject);
  }, [actionType, currentSubject, form]);

  const onSaveSubject = () => {
    createSubjects(form.getFieldsValue()).then(() => {
      message.success(dictionary?.SuccessfullyAdded[language], { duration: 2 });
      closeModal();
    })
      .catch(() => {
        message.error(dictionary?.SomethingWentWrong[language], { duration: 4 })
        closeModal();
      })
  };

  const updateSubject = () => {
    setLoading(true)
    form
      .validateFields().then(() => {
        updateSubjects(form.getFieldsValue())
          .then(() => {
            message.success(dictionary?.SuccessfullyChanged[language], 4);
            setLoading(false)
            closeModal();
          })
          .catch(() => {
            message.error(dictionary?.SomethingWentWrong[language], 4);
            setLoading(false)
            closeModal();
          });
      }
      )
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.FormValidationFail[language], 4);
      });
  }

  function rulesForStudyYear(e) {
    if (!!e) {
      const value = e.target.value;
      const years = value.split('/');
      if (years[0] > years[1]) {
        return {
          validateStatus: 'error',
          help: 'Начало года обучения не может быть больше чем конец года обучения',
        };
      }
      if (!value.match(studyYearRegex)) {
        return { validateStatus: 'error', help: dictionary?.StudyYearField[language] };
      }
      if (!value) {
        return { validateStatus: 'error', help: requiredMessage };
      } else {
        return { validateStatus: 'success', help: null };
      }
    }
  }

  return (
    <Modal
      title={modalTitle}
      visible={visible}
      onOk={actionType === 'save' ? onSaveSubject : updateSubject}
      onCancel={() => closeModal()}
      okText={dictionary?.Save[language]}
      cancelText={dictionary?.Cancel[language]}>
      <Form
        form={form}
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 14 }}
        layout="horizontal"
        initialValues={actionType === 'edit' ? currentSubject : initialState}>
        <Form.Item name="id" style={{ display: 'none' }}>
          <Input type='hidden' value={null} />
        </Form.Item>
        <Form.Item name="institutionId" style={{ display: 'none' }}>
          <Input type='hidden' />
        </Form.Item>
        <Form.Item
          label={dictionary?.Name[language]}
          name="name"
          rules={[
            { required: true, message: requiredMessage },
            { min: 1, message: dictionary?.MaxLengthField[language] },
            { max: 100, message: dictionary?.MaxLengthField[language] }
          ]}>
          <Input placeholder={dictionary?.Name[language]} />
        </Form.Item>
        <Form.Item
          label={dictionary?.Description[language]}
          name="description"
          rules={[
            { required: true, message: requiredMessage },
            { min: 1, message: dictionary?.MaxLengthField[language] },
            { max: 100, message: dictionary?.MaxLengthField[language] }
          ]}>
          <Input placeholder={dictionary?.Description[language]} />
        </Form.Item>
        <Form.Item
          name="langId"
          label={dictionary?.Lang[language]}
          rules={[{ required: true, message: requiredMessage }]}>
          <Select placeholder={dictionary?.Lang[language]} allowClear={true}>
            {languagesType &&
              languagesType.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>

        <Form.Item
          label={dictionary?.StudyYear[language]}
          name="studyYear"
          rules={[
            { required: true, message: requiredMessage },
            {
              message: dictionary?.InvalidStudyYear[language],
            }
          ]}>
          <Input placeholder={dictionary?.StudyYear[language]} type='number' />
        </Form.Item>

        <Form.Item
          label={dictionary?.YearStudy[language]}
          name="yearOfStudy"
          rules={[
            { required: true, message: requiredMessage },
            { pattern: studyYearRegex, message: 'Формат должен быть по типу ХХ/ХХ ' }
          ]}
          {...rulesForStudyYear(studyYear)}>
          <MaskedInput value={studyYear} onChange={setStudyYear} mask="11/11" placeholder="__/__" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
